// 引入vue
import Vue from 'vue'
// 引入Vuex
import Vuex from 'vuex'
//引入user模块
import user from './modules/user'
//引入持久化插件
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const actions = {}
const mutations = {
    OPENCHECK(context, value){
        context.isCheckRole=!context.isCheckRole
    },
    CLEARDATA(context, value){
        for (var key in context) {
            context[key] = undefined;
        }
    },
    USER_SIGNOUT(state){
        Object.key(state).foreach((k)=>{
           Vue.delete(state,k);
        })
    }
}
const state = {isCheckRole:true}
export default new Vuex.Store({
    actions,
    mutations,
    state,
    modules: {
        user
    },
    plugins: [
        createPersistedState({
            key: 'gkzzd_pc_mntb',//要持久化的数据key名
            path: [
                'user',//要持久化的模块名字
            ]
            // storage: window.localStorage  //持久化所有state在本地缓存
        })
    ]
})
